import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./EditProperty.css";

const EditProperty = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProperty = async () => {
      try {
        const response = await fetch(
          `https://realo-realestate.com/api/api/Property/GetProperty/${id}`
        );
        const data = await response.json();

        // Ensure all fields exist in the formData to avoid rendering issues
        const defaultData = {
          title: "",
          description: "",
          address: "",
          city: "",
          state: "",
          zipCode: "",
          propertyType: "",
          isForSale: true,
          isForRent: true,
          price: 0,
          bedrooms: 0,
          bathrooms: 0,
          squareFeet: 0,
          isAvailable: true,
          orientation: "",
          furniture: "",
          heatingSystem: "",
          additionalFeatures: "",
          hasOwnershipDocument: true,
          spaces: 0,
          floorLevel: "",
          country: "",
          neighborhood: "",
          builder: "",
          complex: "",
          latitude: 0,
          longitude: 0,
          exteriorVideo: "",
          interiorVideo: "",
        };

        setFormData({ ...defaultData, ...data });
      } catch (error) {
        console.error("Error fetching property details:", error);
      }
    };
    fetchProperty();
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `https://realo-realestate.com/api/api/Property/PutProperty/${id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error updating property:", errorData);
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      console.log("Property updated successfully!");
      navigate("/dashboard");
    } catch (error) {
      console.error("Error submitting updated property:", error.message);
    }
  };

  return (
    <div className="edit-property-container">
      <div className="edit-property-header">
        <h1>Edit Property</h1>
        <button
          className="edit-property-back"
          onClick={() => navigate("/dashboard")}
        >
          Back to Dashboard
        </button>
      </div>

      <form onSubmit={handleSubmit} className="edit-property-form">
        <div className="edit-property-grid">
          {Object.keys(formData).map((key) => (
            <div key={key} className="edit-property-field">
              <label htmlFor={key} className="edit-property-label">
                {key}
              </label>
              <input
                id={key}
                className="edit-property-input"
                type={
                  typeof formData[key] === "boolean"
                    ? "checkbox"
                    : typeof formData[key] === "number"
                    ? "number"
                    : "text"
                }
                name={key}
                value={
                  typeof formData[key] === "boolean"
                    ? undefined
                    : formData[key] || ""
                }
                checked={typeof formData[key] === "boolean" && formData[key]}
                onChange={handleChange}
              />
            </div>
          ))}
        </div>
        <button className="edit-property-submit" type="submit">
          Update Property
        </button>
      </form>
    </div>
  );
};

export default EditProperty;
